/**
 * MarkdownFallback
 *
 * Renders an envelope's server-rendered `markdown` through the existing chat
 * markdown path (paragraph reveal + citation superscripts).
 *
 * Step 1 routes every intent here except memo/deep_research; the typed leaf
 * renderers land in Step 2 and this stays the safety net for unknown intents
 * and malformed payloads.
 */

import React from 'react';
import MarkdownStream from '../Chat/MarkdownStream';
import { ResearchResponse } from './types';

interface Props {
  response: ResearchResponse;
  isLive: boolean;
  onComplete: () => void;
  onOpenCitation: (url: string) => void;
}

const MarkdownFallback: React.FC<Props> = ({ response, isLive, onComplete, onOpenCitation }) => (
  <MarkdownStream
    text={response.markdown}
    citations={response.citations}
    isLive={isLive}
    onComplete={onComplete}
    onOpenCitation={onOpenCitation}
  />
);

export default MarkdownFallback;
